"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGenericMeasureStaticMethods = void 0;
var genericMeasureUtils_1 = require("./genericMeasureUtils");
var getGenericMeasureStaticMethods = function (num) {
    return {
        sum: (0, genericMeasureUtils_1.wrapReducerFn)(num.add),
        min: (0, genericMeasureUtils_1.wrapReducerFn)(function (left, right) { return (num.compare(left, right) < 0 ? left : right); }),
        max: (0, genericMeasureUtils_1.wrapReducerFn)(function (left, right) { return (num.compare(left, right) < 0 ? right : left); }),
        add: (0, genericMeasureUtils_1.wrapBinaryFn)(num.add),
        subtract: (0, genericMeasureUtils_1.wrapBinaryFn)(num.sub),
        multiply: function (left, right) { return left.times(right); },
        divide: function (left, right) { return left.over(right); },
        prefix: function (prefix, multiplier) {
            return function (measure) {
                var symbol = measure.symbol;
                return measure.scale(multiplier).withSymbol(symbol && "".concat(prefix).concat(symbol));
            };
        },
    };
};
exports.getGenericMeasureStaticMethods = getGenericMeasureStaticMethods;
//# sourceMappingURL=genericMeasureStatic.js.map